var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 898,
    height: 898,
    viewBox: "0 0 898 898",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M278.46 278.477H190.739C177.672 278.477 165.142 283.668 155.904 292.906L0 448.81L155.904 604.712C165.142 613.951 177.672 619.142 190.739 619.142H278.46L108.128 448.81L278.46 278.477Z",
    fill: "#4DFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M619.54 278.477H707.261C720.328 278.477 732.858 283.668 742.096 292.906L898 448.81L742.096 604.712C732.858 613.951 720.328 619.142 707.261 619.142H619.54L789.872 448.81L619.54 278.477Z",
    fill: "#4DFFFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M619.124 278.46V190.737C619.124 177.672 613.934 165.142 604.694 155.904L448.792 0L292.888 155.904C283.649 165.142 278.458 177.672 278.458 190.737V278.46L448.792 108.128L619.124 278.46Z",
    fill: "#4DFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.458 619.129V706.85C278.458 719.916 283.649 732.447 292.888 741.685L448.792 897.589L604.694 741.685C613.934 732.447 619.124 719.916 619.124 706.851V619.129L448.792 789.461L278.458 619.129Z",
    fill: "#4DFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M403.709 461.167V548.888L480.749 471.849C489.987 462.609 495.177 450.078 495.177 437.014V349.291L418.137 426.332C408.899 435.571 403.709 448.101 403.709 461.167Z",
    fill: "#4DFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMobile);
export default __webpack_public_path__ + "static/media/logo_mobile.aec841637733c5763f1584d4da9e45be.svg";
export { ForwardRef as ReactComponent };